// extracted by mini-css-extract-plugin
export default {"nextButton":"nextButton_nextButton__iC6z1"};